import React, { useState, useEffect } from "react";
import { Button, Input } from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import "./login.scss";

const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function validateEmail(email) {
  return EMAIL_REGEX.test(email);
}

function Login(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const auth = useAuth();

  const { isSignup } = props;

  useEffect(() => {
    if (auth.error) {
      setPassword("");
    }
  }, [auth, password]);

  if (auth.user) {
    return <Redirect to="/" />;
  }

  if (auth.user === null) {
    return <></>;
  }

  const isValidEmail = validateEmail(email);

  function handleSubmit(email, password) {
    const action = isSignup ? auth.signup : auth.signin;
    window.analytics.track(isSignup ? "signup" : "login");
    return action(email, password);
  }

  return (
    <div className="email-submit single-page-card">
      <img src="/logos/logo.svg" alt="XLearn logo" />

      <h4 className="title">{isSignup ? "Sign up" : "Log in"}</h4>

      <Input
        autoFocus
        value={email}
        onChange={evt => {
          setEmail(evt.target.value);
          auth.reset();
        }}
        name="email"
        type="email"
        placeholder="your email"
      />
      <Input
        value={password}
        onChange={evt => {
          setPassword(evt.target.value);
          auth.reset();
        }}
        name="password"
        type="password"
        placeholder="password"
      />

      <span className={`error-label ${!auth.error && "hidden"}`}>
        Invalid email or password.
      </span>

      <Button
        disabled={!isValidEmail}
        onClick={() => handleSubmit(email, password)}
        size="lg"
        color="primary"
      >
        {isSignup ? "Signup" : "Login"}
      </Button>

      <Link to={isSignup ? "/login" : "/signup"}>
        {isSignup
          ? "Already have an account? Log in"
          : "Sign up for an account"}
      </Link>
    </div>
  );
}

export { Login };
